/**
 * What the chart's marks mean, in two rows: first the plot's own marks (the
 * median line, the band of the usual range, the red area where the site was
 * down), then the status lane's colours (`LaneLegend`).
 *
 * Each swatch mirrors its mark: a short stroke for the line, a filled box for
 * an area. The boxes are a little stronger than the plot's own fills, which
 * are faint on purpose and would read as empty at swatch size.
 */
import type { T } from "../words";
import { LaneLegend } from "./StatusLane";

const MARKS = [
  { key: "median", swatch: "h-0.5 w-3.5 rounded-full bg-[var(--color-primary)]" },
  { key: "band", swatch: "size-2.5 rounded-[3px] bg-[color-mix(in_oklab,var(--color-primary)_30%,transparent)]" },
  { key: "down", swatch: "size-2.5 rounded-[3px] bg-[color-mix(in_oklab,var(--color-destructive)_30%,transparent)]" },
] as const;

export function ChartLegend({ t }: { t: T }) {
  return (
    <div className="grid gap-1.5">
      <div className="crm-mut flex flex-wrap gap-x-4 gap-y-1 text-[11.5px]">
        {MARKS.map((mark) => (
          <span key={mark.key} className="inline-flex items-center gap-1.5">
            <span aria-hidden className={`inline-block shrink-0 ${mark.swatch}`} />
            {t(`monitoring.chart.legend.${mark.key}`)}
          </span>
        ))}
      </div>
      <LaneLegend t={t} />
    </div>
  );
}
